export default __webpack_public_path__ + "static/media/Virtual5.9489026a.webp";